import { errorHandler } from '../common';
import Api from '../api';
import { cleanObject } from '@/common/functions/cleanObject';
const { axios: api } = Api;
const queryString = require('query-string');

const ENTITY_NAME = 'mail-category';

export const getMailCategories = () =>
	errorHandler(async () => {
		const data = await api.get(`/${ENTITY_NAME}/`);
		return { data: data.data };
	});

export const getMailOptionsCategories = (payload) =>
	errorHandler(async () => {
		const data = await api.get(
			`/${ENTITY_NAME}/options?${queryString.stringify(cleanObject(payload), {
				arrayFormat: 'bracket',
			})}`,
		);
		return { data: data.data };
	});

export const updateMailCategory = (payload) =>
	errorHandler(async () => {
		const data = await api.patch(`/${ENTITY_NAME}/${payload._id}`, payload);
		return { data: data.data };
	});

export const createMailCategory = (payload) =>
	errorHandler(async () => {
		const data = await api.post(`/${ENTITY_NAME}`, payload);
		return { data: data.data };
	});

export const testCategoryEmail = (payload) =>
	errorHandler(async () => {
		const data = await api.post(`/${ENTITY_NAME}/test-mail`, payload);
		return { data: data.data };
	});
